import { KoAssertsView, KoButton, KoLoader,  KoTable, KoTooltips } from 'packages';
import KoIcon from '@kwapio/icons';
import React, { useState, useEffect } from 'react';
import {COLUMNS_ATTACHMENTS} from './constant';
import styles from './curd.module.scss';
import { downloadFile } from 'pages/drive/downloaddocx';
import { CurdAPI } from './curd.service';
export default function Attachemnts({ticketId, className, refresh, workspaceId, onRemoveFile, setAttachementsList }) {
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [openFileCreate, setOpenFileCreate] = useState(false);
  const [savingTextStatus, setSavingTextStatus] = useState('');
  
  useEffect(() => {
    if(!ticketId){
      return;
    }
    setLoading(true);
    CurdAPI.getAttachments(ticketId, workspaceId).then(
      (data) => {
        setLoading(false);
        setFiles(data['attachments']);
        setAttachementsList &&setAttachementsList(data['attachments']);
      },
      (err) => {
        setLoading(false);
        console.log(err);
      }
    );
  }, [refresh]);

  const onCellClick = (data) => {
    if (data?.type === 'docx') {
      window.open(`/open/document/root/${data?.uid}`, '_blank');

    }else{
      setCurrentRecord(data);
      setOpenFileCreate(true);
    }
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.table} tableBtn columnsRight`} onClick={() => setCurrentRecord(row)}>
        <KoTooltips title={'Download'}>
          <KoButton className={'btn'} iconBtn={true} onClick={() => downloadFile(row?.url, currentRecord?.name || row?.name, setLoading)}  icon={<KoIcon width={14} height={14} name={'DownloadOutlined'} />} />
        </KoTooltips>
        {onRemoveFile && row?.uid?.includes('rc-') &&  <KoTooltips title={'Delete'}>
          <KoButton onClick={() => onRemoveFile(row)}  className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>}
      </div>;
    }
  }];

  return (
    <div className={`${className? className : ''} tableCard`}>
      {loading && <KoLoader />}
      <div className={styles.table}>
        <KoTable rowKey={'uid'}
          onCellClick={onCellClick}
          data={{ columns: COLUMNS_ATTACHMENTS, rows: files }}
          extraColumnsRight={columnsRight}
          maxHeight={79} />
      </div>
      {openFileCreate && <KoAssertsView
        openFileCreate={openFileCreate}
        showComments={false}
        source={'attachments'}
        isLoading={loading}
        savingTextStatus={savingTextStatus}
        actions={['download', 'updated']}
        onDownload={() => {downloadFile(currentRecord?.url, currentRecord?.name, setLoading, setSavingTextStatus('Downloading...'));}}
        fileDetails={currentRecord}
        setOpenFileCreate={setOpenFileCreate}
        documentId={currentRecord?.documentId} />}
    </div>
   
  );
}
